import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    freeze: {
        id: 'cards.actions.freeze',
        defaultMessage: 'Freeze',
    },
    unfreeze: {
        id: 'cards.actions.unfreeze',
        defaultMessage: 'Unfreeze',
    },
})
